"use client";

import { useEffect, useState } from "react";
import teacherAPI from "../../../services/teacher/teacher";

export default function ActiveUser() {
  const [userCount, setUserCount] = useState<number | null>(null);
  const [isLoadingCount, setIsLoadingCount] = useState(false);

  const fetchCount = async () => {
    setIsLoadingCount(true);
    try {
        const res = await teacherAPI.countTeacher();
        if (res && typeof (res as { count?: unknown}).count !== "undefined") {
            setUserCount((res as { count?: number }).count ?? null);
        }
    } catch {
        console.log("Failed to fetch teacher count");
    } finally {
        setIsLoadingCount(false);
    }
  };

  useEffect(() => {
    fetchCount();
  }, []);

  return (
    <div className="flex h-full w-full flex-col px-6 py-4">
      <p className="mt-4 text-lg font-normal leading-[1.1] text-[#4E4E4E]">Active User</p>
      <p className="mt-4 text-3xl font-bold leading-none text-[#0092D7]">
        {isLoadingCount ? (
          <span className="text-5xl text-[#9aa0a6]">...</span>
        ) : userCount !== null ? (
          userCount
        ) : (
          "-"
        )}
      </p>
      {/* <p className="mt-4 text-base font-normal leading-none text-[#005A96]">+12% จากเดือนที่แล้ว</p> */}
    </div>
  );
}